import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { GroupPriceByOrganizationIdDto } from 'src/app/core/api/models';
import { GroupPricesService } from 'src/app/core/api/services';
import { BasePageComponent } from 'src/app/pages/shared/base/components/base-page.component';
import { GroupPriceDetailsService } from './../../../../core/api/services/group-price-details.service';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { GroupPriceDetailsFormComponent } from "../../group-price/group-price-details-form/group-price-details-form.component";
import { GroupPriceSocialMediaDetailFormComponent } from "../../group-price/group-price-social-media-detail-form/group-price-social-media-detail-form.component";


@Component({
    selector: 'app-organization-group-price-detail',
    templateUrl: './organization-group-price-detail.component.html',
    styleUrls: ['./organization-group-price-detail.component.scss'],
    imports: [BaseIndexModule, GroupPriceDetailsFormComponent, GroupPriceSocialMediaDetailFormComponent]
})
export class OrganizationGroupPriceDetailComponent
  extends BasePageComponent
  implements OnInit
{
  //#region properties
  @Input() groupPriceDetail: GroupPriceByOrganizationIdDto;
  @Input() organizationId: number;
  @Input() organizationName: string;

  @Output('closePage') output_closePage = new EventEmitter<boolean>();

  //#endregion

  constructor(
    protected groupPriceDetailsService: GroupPriceDetailsService,
    protected groupPricesService: GroupPricesService
  ) {
    super();
  }

  ngOnInit(): void {
    this.title = 'common.groupPriceDetail';
  }

  ngAfterViewInit(): void {
    this.getGroupPricesDetailApi();
  }

  //#region Api

  getGroupPricesDetailApi() {
    this.unSubs();

    this.loading = true;

    this.groupPricesService
      .groupPricesGetGroupPriceByOrganizationId({
        body: { organizationId: this.organizationId },
      })
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        this.groupPriceDetail = res.data;
      });
  }

  //#endregion

  onReset() {
    if (this.loading) return;
    this.getGroupPricesDetailApi();
  }

  onClose() {
    this.loading = false;
    this.formPageConfig.isEditMode = false;
    this.unSubs();
    this.output_closePage.emit(true);
  }
}
